import { Controller } from '@hotwired/stimulus';

// Single-select status filter for the VAS quotes tab: toggles the active pill
// styling and shows/hides quote cards by their data-status bucket, then asks the
// selection counter to recount against the now-visible cards.
export default class extends Controller {
  static targets = ['pill', 'card'];

  connect() {
    this.applyFilter('all');
  }

  filter(event) {
    this.applyFilter(event.currentTarget.dataset.filterKey);
  }

  applyFilter(key) {
    this.pillTargets.forEach((pill) => {
      const isActive = pill.dataset.filterKey === key;
      const activeClasses = pill.dataset.activeClass.split(' ');
      const inactiveClasses = pill.dataset.inactiveClass.split(' ');
      pill.classList.remove(...(isActive ? inactiveClasses : activeClasses));
      pill.classList.add(...(isActive ? activeClasses : inactiveClasses));
      pill.setAttribute('aria-pressed', isActive);
    });

    this.cardTargets.forEach((card) => {
      card.hidden = key !== 'all' && card.dataset.status !== key;
    });

    this.dispatch('filtered');
  }
}
